import { createAsyncThunk } from "@reduxjs/toolkit";
import { API_URL } from "../../../app/config";
import { axiosApiInstance } from "../../../app/axios";
import { ErrorToast, SuccessToast } from "../../../components/toast/Toasts";

export const getAllInquiry = createAsyncThunk(
  "Inquiry/FindAllInquiry",
  async (formdata: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Inquiry/FindAllInquiry`,
        formdata
      );
      return response.data?.Data;
    } catch (error: any) {
      console.error("Error Fetching Inquiry:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const updateFollowUpStatus = createAsyncThunk(
  "LeadStage/FollowupStatusUpdate",
  async (FollowUpData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/LeadStage/FollowupStatusUpdate`,
        FollowUpData,
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error updating followup status:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const getFollowupsByInquiryID = createAsyncThunk(
  "LeadStage/FollowupListByID",
  async (formData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/LeadStage/FollowupListByID`,
        formData,
      );
      return response.data?.Data;
    } catch (error: any) {
      // ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error Fetching Inquiries:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const insertFollowUp = createAsyncThunk(
  "LeadStage/InsertFollowup",
  async (FollowUpData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/LeadStage/InsertFollowup`,
        FollowUpData,
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error inserting followup:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);
